// Left rail of the login page: wordmark, live clock, attempt meter, footer.

import { useEffect, useState } from "react";
import { formatClock } from "../lib/time.js";

const METER_SLOTS = Array.from({ length: 5 });

function Meter({ filled, total = 5 }) {
  return (
    <div className="flex items-center gap-2 tabular">
      {METER_SLOTS.map((_, i) => (
        <span
          key={i}
          className={
            i < filled
              ? "inline-block h-2 w-2 rounded-full bg-aught-oxide"
              : "inline-block h-2 w-2 rounded-full bg-aught-railMute/60"
          }
        />
      ))}
    </div>
  );
}

export default function LobbyRail({ failedCount = 0, maxAttempts = 3, lastAttemptAt = null, lockedUntil = null }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const i = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(i);
  }, []);

  const filledSlots = Math.min(5, Math.round((failedCount / Math.max(1, maxAttempts)) * 5));

  return (
    <aside className="relative hidden md:flex md:w-[42%] lg:w-[40%] xl:w-[38%] bg-aught-steel text-aught-paper flex-col justify-between p-10 lg:p-14 steel-tex overflow-hidden">
      <div>
        <h1 className="font-serif text-[clamp(2.5rem,5vw,4.25rem)] leading-[0.95] tracking-tightest text-aught-paper">
          Aught
        </h1>
        <p className="mt-2 font-mono text-[11px] tracking-[0.18em] uppercase text-aught-railInk">
          Lobby 01 · Floor G
        </p>
      </div>

      <div className="space-y-8">
        <div>
          <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-aught-railInk mb-3">
            Local time
          </p>
          <p className="font-mono tabular text-status text-aught-paper">
            {formatClock(now)}
          </p>
        </div>

        <div>
          <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-aught-railInk mb-3">
            Attempts
          </p>
          <div className="flex items-center gap-4">
            <Meter filled={filledSlots} total={5} />
            <span className="font-mono tabular text-sm text-aught-paper">
              {failedCount}/{maxAttempts}
            </span>
          </div>
        </div>

        <div>
          <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-aught-railInk mb-3">
            Last attempt
          </p>
          <p className="font-mono tabular text-sm text-aught-paper">
            {formatClock(lastAttemptAt)}
          </p>
        </div>

        {lockedUntil && (
          <div>
            <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-aught-fail mb-3">
              Locked until
            </p>
            <p className="font-mono tabular text-sm text-aught-paper">
              {formatClock(lockedUntil)}
            </p>
          </div>
        )}
      </div>

      <div className="space-y-2">
        <p className="font-serif text-lg text-aught-paper">
          Single-door access.
        </p>
        <p className="font-serif text-base text-aught-railInk italic">
          No public registration.
        </p>
      </div>
    </aside>
  );
}
